import {
  GET_ARIZONADATA,
  GET_ARIZONADATA_JAN_2021,
  GET_ARIZONADATA_FEB_2021,
  GET_ARIZONADATA_DEC_2020,
  GET_ARIZONADATA_NOV_2020,
  GET_ARIZONADATA_OCT_2020,
  GET_ARIZONADATA_SEP_2020,
  GET_ARIZONADATA_AGO_2020,
  GET_ARIZONADATA_JUL_2020,
  GET_ARIZONADATA_JUN_2020,
  GET_ARIZONADATA_MAY_2020,
  GET_ARIZONADATA_APR_2020,
  GET_ARIZONADATA_MAR_2020,
  GET_ARIZONADATA_AGO_2021,
  GET_ARIZONADATA_APR_2021,
  GET_ARIZONADATA_DEC_2021,
  GET_ARIZONADATA_JUL_2021,
  GET_ARIZONADATA_JUN_2021,
  GET_ARIZONADATA_MAR_2021,
  GET_ARIZONADATA_MAY_2021,
  GET_ARIZONADATA_NOV_2021,
  GET_ARIZONADATA_OCT_2021,
  GET_ARIZONADATA_SEP_2021,
} from "../actions/types";

const initialState = {
  arizonadatas: [],
  azdec2021: [],
  aznov2021: [],
  azoct2021: [],
  azsep2021: [],
  azago2021: [],
  azjul2021: [],
  azjun2021: [],
  azmay2021: [],
  azapr2021: [],
  azmar2021: [],
  azfeb2021: [],
  azjan2021: [],
  azdec2020: [],
  aznov2020: [],
  azoct2020: [],
  azsep2020: [],
  azago2020: [],
  azjul2020: [],
  azjun2020: [],
  azmay2020: [],
  azapr2020: [],
  azmar2020: [],
};
// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ARIZONADATA:
      return {
        ...state,
        arizonadatas: payload,
      };
    case GET_ARIZONADATA_DEC_2021:
      return {
        ...state,
        azdec2021: payload,
      };
    case GET_ARIZONADATA_NOV_2021:
      return {
        ...state,
        aznov2021: payload,
      };
    case GET_ARIZONADATA_OCT_2021:
      return {
        ...state,
        azoct2021: payload,
      };
    case GET_ARIZONADATA_SEP_2021:
      return {
        ...state,
        azsep2021: payload,
      };
    case GET_ARIZONADATA_AGO_2021:
      return {
        ...state,
        azago2021: payload,
      };
    case GET_ARIZONADATA_JUL_2021:
      return {
        ...state,
        azjul2021: payload,
      };
    case GET_ARIZONADATA_JUN_2021:
      return {
        ...state,
        azjun2021: payload,
      };
    case GET_ARIZONADATA_MAY_2021:
      return {
        ...state,
        azmay2021: payload,
      };
    case GET_ARIZONADATA_APR_2021:
      return {
        ...state,
        azapr2021: payload,
      };
    case GET_ARIZONADATA_MAR_2021:
      return {
        ...state,
        azmar2021: payload,
      };
    case GET_ARIZONADATA_FEB_2021:
      return {
        ...state,
        azfeb2021: payload,
      };
    case GET_ARIZONADATA_JAN_2021:
      return {
        ...state,
        azjan2021: payload,
      };
    case GET_ARIZONADATA_DEC_2020:
      return {
        ...state,
        azdec2020: payload,
      };
    case GET_ARIZONADATA_NOV_2020:
      return {
        ...state,
        aznov2020: payload,
      };
    case GET_ARIZONADATA_OCT_2020:
      return {
        ...state,
        azoct2020: payload,
      };
    case GET_ARIZONADATA_SEP_2020:
      return {
        ...state,
        azsep2020: payload,
      };
    case GET_ARIZONADATA_AGO_2020:
      return {
        ...state,
        azago2020: payload,
      };
    case GET_ARIZONADATA_JUL_2020:
      return {
        ...state,
        azjul2020: payload,
      };
    case GET_ARIZONADATA_JUN_2020:
      return {
        ...state,
        azjun2020: payload,
      };
    case GET_ARIZONADATA_MAY_2020:
      return {
        ...state,
        azmay2020: payload,
      };
    case GET_ARIZONADATA_APR_2020:
      return {
        ...state,
        azapr2020: payload,
      };
    case GET_ARIZONADATA_MAR_2020:
      return {
        ...state,
        azmar2020: payload,
      };
    default:
      return state;
  }
}
